import { useEffect, useState } from 'react';
import { getImageFrame } from '@bynder-studio/render-web';

const TIME = 0.039;

const transparentImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

export default function useContentPreviewUrl(src: string, type = 'video', isAlpha = false) {
    const [url, setUrl] = useState<string>(type === 'video' ? transparentImage : src);

    useEffect(() => {
        if (!src) {
            setUrl(transparentImage);

            return;
        }

        if (type !== 'video') {
            setUrl(src);

            return;
        }

        let objectUrl: string | null = null;
        const video = document.createElement('video');
        video.crossOrigin = 'anonymous';
        video.src = src;

        const handleLoadedmetadata = () => {
            video.currentTime = TIME;
        };

        const handleSeeked = () => {
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight / (isAlpha ? 2 : 1);
            const ctx = canvas.getContext('2d')!;

            getImageFrame(video, isAlpha)
                .then((img) => {
                    if (!img) {
                        video.remove();

                        return;
                    }

                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob((blob) => {
                        if (blob) {
                            objectUrl = URL.createObjectURL(blob);
                            setUrl(objectUrl);
                        }

                        video.remove();
                    });
                })
                .catch((error) => {
                    console.log(error, 'error');
                    video.remove();
                });
        };

        video.addEventListener('loadedmetadata', handleLoadedmetadata);
        video.addEventListener('seeked', handleSeeked);

        return () => {
            video.removeEventListener('loadedmetadata', handleLoadedmetadata);
            video.removeEventListener('seeked', handleSeeked);
            video.remove();

            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [src, type, isAlpha]);

    return url;
}
